module.exports = __webpack_public_path__ + "img/keyboard_A.6f220c99.png";